// import 'swiper/css/bundle'
import "swiper/css";
// import "swiper/css/pagination";
import "swiper/css/navigation";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const sliders = document.querySelectorAll(".testimonials-swiper");

sliders.forEach((slider, index) => {
  const prevBtn = slider.closest(".section-testimonials-slider")?.querySelector(".testimonials-prev");
  const nextBtn = slider.closest(".section-testimonials-slider")?.querySelector(".testimonials-next");

  slider.classList.add(`testimonials-swiper-${index}`);
  if (prevBtn) prevBtn.classList.add(`testimonials-prev-${index}`);
  if (nextBtn) nextBtn.classList.add(`testimonials-next-${index}`);

  new Swiper(`.testimonials-swiper-${index}`, {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    loop: false,
    navigation: {
      nextEl: nextBtn ? `.testimonials-next-${index}` : null,
      prevEl: prevBtn ? `.testimonials-prev-${index}` : null,
    },
    breakpoints: {
      1200: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
  });
});
